// JKHive-flavored Sales Summary — reuses the admin-sales-summary page component
// inside the JKHive layout.
import React from 'react';
import AdminSalesSummary from '../admin-sales-summary';

const JKHiveSalesSummary = () => <AdminSalesSummary />;
export default JKHiveSalesSummary;
